import { fetchData } from './fetchData';

export const loadAvailableGroomers = ({ luid, date, time }) => {
  const dateQuery =
    date && time ? `?date_start=${date}&time_start=${time}` : '';
  return (dispatch, getState) =>
    fetchData({
      endpoint: `location/${luid}/user/availability/consumer${dateQuery}`,
      actions: [null, null, null],
    })(dispatch, getState);
};
